import React from 'react';
import Layout from '../components/layout/Layout';
import { FiClock, FiBookmark, FiArrowRight } from '../utils/icons';
import { useLanguage } from '../utils/languageContext';

const Saved = () => {
  const { translations } = useLanguage();
  
  // Mock saved articles data
  const savedArticles = [
    {
      id: 1,
      title: 'Understanding Risk-Adjusted Returns in Investment Management',
      excerpt: 'Learn how to evaluate investments on a risk-adjusted basis to make better decisions for your portfolio.',
      category: 'Investing',
      date: '2023-10-15',
      readTime: '8 min',
      image: 'https://images.unsplash.com/photo-1604594849809-dfedbc827105?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80'
    },
    {
      id: 2,
      title: 'Tax Optimization Strategies for High-Income Earners',
      excerpt: 'Discover advanced tax planning techniques to minimize your tax burden while staying fully compliant with regulations.',
      category: 'Taxes',
      date: '2023-09-28',
      readTime: '12 min',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80'
    },
    {
      id: 3,
      title: 'The Psychology of Spending: How to Control Impulse Purchases',
      excerpt: 'Explore the psychological triggers behind spending and learn practical techniques to manage impulsive buying habits.',
      category: 'Behavioral Finance',
      date: '2023-11-05',
      readTime: '6 min',
      image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80'
    },
    {
      id: 4,
      title: 'Sustainable Investing: Balancing Profits and Environmental Impact',
      excerpt: 'How to build a portfolio that delivers strong returns while supporting companies with sustainable practices.',
      category: 'ESG Investing',
      date: '2023-10-22',
      readTime: '9 min',
      image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80'
    },
  ];
  
  const handleRemoveBookmark = (id: number) => {
    console.log('Remove bookmark:', id);
    // In a real app, this would update state and potentially a backend
  };
  
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-text mb-2">{translations.savedArticles}</h1>
          <p className="text-text/70">
            Articles you've saved for later reading.
          </p>
        </div>
        
        <div className="grid gap-6">
          {savedArticles.map(article => (
            <div 
              key={article.id}
              className="bg-foreground rounded-xl border border-border overflow-hidden flex flex-col md:flex-row"
            >
              <div className="md:w-1/4 h-48 md:h-auto overflow-hidden">
                <img 
                  src={article.image} 
                  alt={article.title} 
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <span className="text-xs font-medium px-2 py-1 rounded-full bg-primary/10 text-primary">
                        {article.category}
                      </span>
                    </div>
                    
                    <button 
                      onClick={() => handleRemoveBookmark(article.id)}
                      className="text-text/70 hover:text-accent transition-colors"
                      aria-label="Remove from bookmarks"
                    >
                      <FiBookmark size={20} className="fill-current" />
                    </button>
                  </div>
                  
                  <h2 className="text-xl font-semibold mb-2">{article.title}</h2>
                  <p className="text-text/70 text-sm mb-4">{article.excerpt}</p>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-sm text-text/50">
                    <span className="flex items-center mr-4">
                      <FiClock size={14} className="mr-1" />
                      {article.readTime}
                    </span>
                    <span>{article.date}</span>
                  </div>
                  
                  <button className="flex items-center text-primary hover:text-primary/80 font-medium text-sm transition-colors">
                    Read Article
                    <FiArrowRight size={16} className="ml-1" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {savedArticles.length === 0 && (
          <div className="bg-foreground rounded-xl border border-border p-8 text-center">
            <FiBookmark size={48} className="mx-auto mb-4 text-text/30" />
            <h2 className="text-xl font-semibold mb-2">No saved articles yet</h2>
            <p className="text-text/70 mb-6">
              Browse our financial insights and save articles you'd like to read later.
            </p>
            <button className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors inline-flex items-center">
              Discover Articles
              <FiArrowRight size={16} className="ml-2" />
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Saved; 